import React, { ComponentType } from 'react';

type LazyFactory<T extends ComponentType<any>> = () => Promise<{ default: T }>;
type PreloadableComponent<T extends ComponentType<any>> = T & { preload: LazyFactory<T> };

export const lazyPreload = <T extends ComponentType<any>>(importStatement: LazyFactory<T>): PreloadableComponent<T> => {
  const Component = React.lazy(importStatement) as unknown as PreloadableComponent<T>;
  Component.preload = importStatement;
  return Component;
};
